// extracted by mini-css-extract-plugin
module.exports = {"preserveOutline":"CloseButton_preserveOutline__KpcQJ","closeButton":"CloseButton_closeButton__3MfY9 CloseButton_preserveOutline__KpcQJ","img":"CloseButton_img__wOG9K"};